import useCustomWindowDimensions from "@hooks/use-custom-window-dimensions";
import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import { Text, useSx } from "dripsy";
import AnimatedPressable from "./animated-pressable";
import * as React from "react";
import { useBottomTabIndex, useNavigation } from "react-native-ridge-navigation";

import Spacer from "./Spacer";
import ArrowLeft from "./icons/arrow-left";
import { Platform } from "react-native";
import { BottomRoots } from "../Navigator";

function BackButton({
  onPress,
  withText = false,
  backgroundColor = "$background",
}: {
  withText?: boolean;
  backgroundColor?: DripsyColor;
  onPress?: () => void;
}) {
  const { pop, canNavigateBack } = useNavigation();
  const { width } = useCustomWindowDimensions();
  const sx = useSx();

  const isBigScreen = width > 1100;

  const animatedColor = useDripsyColor({ color: backgroundColor });
  const pressedColor = useDripsyColor({
    color: (() => {
      if (backgroundColor === "$secondaryBackground") {
        return "$secondaryBackgroundPressed";
      }
      if (backgroundColor === "$background") {
        return "$backgroundPressed";
      }
      // console.log("color not mapped");
      return "$secondaryBackgroundPressed";
    })(),
  });
  const animate = React.useMemo(
    () =>
      ({ hovered, pressed }: any) => {

        return {
          backgroundColor: hovered || pressed ? pressedColor : animatedColor,
        };
      },
    []
  );
  const { currentTab, switchToTab } = useBottomTabIndex();

  const canGoBack = canNavigateBack(1);
  const goToOtherTab = !canGoBack && !isBigScreen && Platform.OS === "web" && currentTab !== BottomRoots.Home;
  if (!canNavigateBack(1) && !goToOtherTab) {
    return null;
  }
  return (
    <AnimatedPressable
      hitSlop={{ top: 20, right: 20, left: 20, bottom: 5 }}
      onPress={
        goToOtherTab
          ? () => {
              if (currentTab === BottomRoots.Cart) {
                switchToTab(BottomRoots.Products);
              } else {
                switchToTab(BottomRoots.Home);
              }
            }
          : onPress || (() => pop())
      }
      animate={animate}
      style={sx({
        alignItems: "center",
        justifyContent: "center",
        width: withText && isBigScreen ? "auto" : 46,
        px: withText && isBigScreen ? "$3" : 0,
        height: 46,
        borderRadius: 100,
        flexDirection: "row",
        alignSelf: "flex-start",
        borderWidth: 2,
        borderColor: "$lightGrey",
      })}
    >
      <>
        <ArrowLeft color="$primary" width={16} height={14} />

        {withText && isBigScreen ? (
          <>
            <Spacer horizontal size="$2" />
            <Text
              sx={{
                color: "$primary",
                fontWeight: "600",
              }}
            >
              Terug
            </Text>
          </>
        ) : null}
      </>
    </AnimatedPressable>
  );
}
export default BackButton;
